module.exports = __webpack_public_path__ + "img/tu4.962fef4e.png";